import request from './ajax'
// 资金路由模块
const withdrawUrl = '/api/withdraw/'
// 获取提现配置
export const getWithdrawConfig = (data) => request(withdrawUrl + 'config', 'post', { ...data })
// 发起提现
export const setWithdraw = (data) => request(withdrawUrl + 'withdraw', 'post', { ...data })
// 获取提现列表
export const getWithdrawList = (data) => request(withdrawUrl + 'list', 'post', { ...data })
